type AlertVariant = "success" | "error" | "info";

const VARIANT_STYLES: Record<AlertVariant, string> = {
  success: "bg-green-soft text-[#3F7A54]",
  error: "bg-red-soft text-[#C0453A]",
  info: "bg-blue-soft text-[#4750C4]",
};

export function Alert({
  variant,
  children,
}: {
  variant: AlertVariant;
  children: React.ReactNode;
}) {
  if (!children) return null;

  return (
    <div className={`rounded-xl px-4 py-3 text-sm font-medium ${VARIANT_STYLES[variant]}`}>
      {children}
    </div>
  );
}
